
import './ProgressBarTable.css';
import { useState, useEffect, useRef } from "react";
function ProgressBarTable({delayMax = 60, isFound = false}) {

    const [currentDelay, setCurrentDelay ] = useState(0);
    const [hasFinished, setHasFinished] = useState(false);

    async function waitForProgress(){
        await timeout(10);
        let val = isFound ? 0.05 : 0.0001;
        let res = currentDelay + (val * delayMax)
        setCurrentDelay(res);
        if (res >=100){
            await timeout(1000);
            if (res <=100) return;
            setHasFinished(true);
        }
    }

    const resetProgressBar = ()=>{
        setHasFinished(false);
        setCurrentDelay(0);
    }
  useEffect(() => {
    if (delayMax <= 0 || currentDelay > 100) return;
    waitForProgress()
}, [currentDelay]);

useEffect(() => {
    if (currentDelay > 0 && isFound == false){
        resetProgressBar();
    }
}, [isFound]);

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

    return (
        <div className="table_progress_bar_container">
                  <div className={"table_progress_bar " + (hasFinished ? "table_progress_bar_disapear": "")} style={{width: currentDelay + '%'}}></div>
        </div>
    )
}
export default ProgressBarTable;